
import './App.css';
import Tv from'./components/Tv'

function App() {
  return (
    <div className="App">
      <Tv/>
    </div>
  );
}

export default App;
